import { BaseDialog } from "@/lib/Components/Dialog/BaseDialog";
import { TextInput } from "@/lib/Components/Form/Inputs/TextInput";
import { TextAreaInput } from "@/lib/Components/Form/Inputs/TextAreaInput";
import { LocationRadiusInput } from "@/app/Settings/Admin/RelocationPages/Components/LocationRadiusSelector";
import { DialogSubmitButton } from "@/lib/Components/Dialog/Components/DialogSubmitButton";
import { GenericForm } from "@/lib/Components/Form/Forms/GenericForm";
import {
  useGqlMutation,
  useSuspenseGqlQuery,
} from "@/lib/GraphQLCodegen/fetcher";
import { relocationPageQuery } from "@/app/Settings/Admin/RelocationPages/queries/relocationPageQuery";
import { UpdateRelocationPageInput } from "@/gql/graphql";
import { updateRelocationPageMutation } from "@/app/Settings/Admin/RelocationPages/queries/relocationPageMutations";
import { useDialogState } from "@/lib/Components/Dialog/Hooks/useDialogState";
import { RegionInput } from "@/app/Common/Components/RegionInput";

export function UpdateRelocationPageDialog({
  relocationPageSlug,
}: {
  relocationPageSlug: string;
}) {
  const { mutateAsync } = useGqlMutation(updateRelocationPageMutation);
  const { data } = useSuspenseGqlQuery(relocationPageQuery, {
    slug: relocationPageSlug,
  });

  if (!data.relocationPage) {
    throw new Error("Relocation page not found");
  }

  const { close } = useDialogState();

  return (
    <BaseDialog title="Update relocation page">
      <GenericForm<UpdateRelocationPageInput>
        onSubmit={async (values) => {
          await mutateAsync({
            id: data.relocationPage!.id,
            input: values,
          });

          await close();
        }}
        initialValues={{
          title: data.relocationPage.title,
          points: data.relocationPage.points,
          description: data.relocationPage.description,
          region: data.relocationPage.region,
        }}
      >
        <TextInput name="title" label="Title" />
        <RegionInput name="region" label="Region" />

        <TextAreaInput
          name="description"
          label="Description"
          className="col-span-full"
        />

        <LocationRadiusInput name="points" className="col-span-full" />

        <DialogSubmitButton text={"Update page"} />
      </GenericForm>
    </BaseDialog>
  );
}
